import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { DbExercisesService } from 'src/services/db-exercises.service';

@Pipe({
    name: 'fetchExerciseImage',
    standalone: false
})
export class FetchExerciseImagePipe implements PipeTransform {
  constructor(private dbExercisesService: DbExercisesService) {}

  transform(imagePath: string): Observable<string> {
    return of(imagePath).pipe(
      switchMap((path) => this.dbExercisesService.getImageUrl(path)),
      catchError((err) => {
        console.error(err);
        return of('default-image-path.jpg'); // Provide a default image path in case of error
      })
    );
  }
}
